import { makeSystemClient } from 'app/api/fetch';

const client = makeSystemClient('user_groups');

export default client;
